export default {
  pt: {
    // B2BDetail screen
    ERROR_LOAD_B2B_DETAIL: 'Ups! Ocorreu um problema ao carregar os dados.',
    RETRY_AGAIN_LABEL: 'Tentar de novo',
    // B2BLanding screen
    COURSE: 'Cursos',
    TRANSMISSIONS: 'Transmissões',
    ERROR_LOAD_B2B_LANDING: 'Ups! Ocorreu um problema ao carregar a página.',
    // Chat screen
    LOAD_CHAT: ' Carregando bate-papo ... ',
    WAIT_SECONDS: 'Não se preocupe, vai demorar alguns segundos',
    // Detail screen
    HIDDEN_CHAT_LABEL: 'Ocultar bate-papo',
    SHOW_CHAT_LABEL: 'Mostrar chat',
    POP_UP_CHAT_LABEL: 'Popup chat',
    HIDDEN_POP_UP_CHAT_LABEL: 'Ocultar pop-up de bate-papo',
    NOT_MISS_LIVE: 'Não perca o próximo Live!',
    SEE_PROGRAMMING_LABEL: 'Veja a programação',
    SHEDULE_CALENDAR_LABEL: 'Agendar para calendário',
    ERROR_LOAD_DETAIL: 'Ups! Ocorreu um problema ao carregar os dados.',
    // Landing screen
    ERROR_LOAD_LANDING: 'Ups! Ocorreu um problema ao carregar a página.',
    // MembershipSnackbar Component
    COURSE_TO_GROW: 'Mais de um curso para continuar crescendo',
    CORSE_TO_GROW_MESSAGE:
      'Você está prestes a aproveitar uma parte de nossa experiência de aprendizado. Você quer saber mais? Descubra como aprender algo novo todos os dias com uma assinatura.',
    CORSE_TO_GROW_PREMIUM: 'Descubra Premium',
    LIVE_END:
      'Você gostou do show? Leve a sua experiência mais longe com +500 cursos',
    LIVE_MESSAGE_END:
      'É hora de aprofundar o que você aprendeu! Descubra nossas assinaturas Premium e acesse todos os nossos cursos, especializações, mentoria personalizada e muito mais.',
    LIVE_END_LABEL: 'Interessa-me!',
    // ShareDialogContent Component
    SHARE_lIVE: 'Compartilhe isto ao vivo',
    SHARE_LIVE_DESCRIPTION:
      'Gosta do que vê? Compartilhe isso ao vivo para que alcance mais pessoas',
    // VideoInfo Component
    SHARE_BUTTON_LIVE_LABEL: 'Compartilhe isso ao vivo',
    SIGN_UP_FREE_LABEL: 'Inscreva-se gratuitamente!',
    SIGN_UP_LIVE_LABEL: 'Me inscreva',
    ADD_CALENDAR_LABEL: 'Adicionar ao meu calendário',
    // CardLeadPhone Component
    LEARN_WITHOUT_LIMITS: 'Aprenda sem limites',
    DISCOUNT_COURSES:
      'Você está a um telefone de distância de acessar o melhor desconto em 800 cursos com o melhor desconto.',
    TALK: 'Vamos conversar',
    // B2bFooter section
    PRODUCT_B2B: 'Este é um produto para empresas de',
    NEED_HELP: 'Precisa de ajuda?',
    FOLLOW_US: 'Siga-nos',
    COPYRIGTH: 'Todos os direitos reservados',
    // ClassroomCourseList Section
    ERROR_UPS_CLASS_ROOM_COURSE_LIST: 'Ops! Ocorreu um erro',
    TITLE_CLASS_ROOM_COURSE_LIST_1: 'Cursos de',
    TITLE_CLASS_ROOM_COURSE_LIST_2: 'para você',
    NOT_COURSES: 'Sua organização ainda não possui cursos',
    // Hero section
    CREHANA_LEARN: 'Crehana Live: uma nova maneira de aprender',
    SEE_TRANSMISSIONS: 'Veja todas as nossas transmissões',
    NEXT_LIVE: 'PRÓXIMO AO VIVO',
    PREMIUM_EXCLUSIVE: 'EXCLUSIVE PREMIUM',
    GO_TRANSMISSION: 'Vá para a transmissão',
    SEE_INFO: 'Veja mais informações',
    // LiveList section
    ERROR_LIVE_LIST:
      'Ops! Ocorreu um problema ao tentar carregar o Crehana Lives :(',
    ENJOY_TRANSMISSION: 'Aproveite todas as nossas transmissões',
    DISCOVER_LIVE_KIDS: 'Descubra nossas vidas Crehana para crianças!',
    EMPTY_CONTENT_LIVE_LIST: 'Ainda não temos conteúdo para esta categoria',
    BACK_TOP_LIST: 'Voltar para a lista completa',
    // NextLives section.
    KNOW_CLASS_LIVE: 'Conheça nossas próximas aulas ao vivo',
    // Categories secion
    EXPLORE_CATEGORYS: 'Explore nossas categorias',
    // Player section
    EXCLUSIVE_CONTENT: 'Este conteúdo é exclusivo',
    PREMIUM_CREHANA: 'Crehana Premium',
    GO_PREMIUM: 'Torne-se Premium',
    START_IN: 'A transmissão começará em',
    // Information section
    ABOUT_SPEAKER_LABEL: 'SOBRE O SPEAKER',
    DESCRIPTION_LIVE_LABEL: 'DESCRIÇÃO DO AO VIVO',
    SIGN_UP_LIVE_COURSE_LABEL: 'INSCREVA-SE PARA SEU CURSO NO CREHANA',
    MORE_COURSE_INFO_LIVE_LABEL: 'Veja mais informações sobre o curso',
    // LiveTabs section
    HIDDEN_CHAT_LIVE_LABEL: 'O chat está escondido',
    SHOW_CHAT_LIVE_LABEL: 'Mostrar chat aqui',
    ABOUT_TAB_LIVE_LABEL: 'Sobre o Live',
    QUESTION_LIVE_LABEL: 'Perguntas',
    CHAT_LIVE_LABEL: 'chat',
    // Question section
    UPS_ERROR_LIVE_LABEL:
      'Ups! Ocorreu um erro ao obter informações sobre as perguntas. ',
    NOT_QUESTIONS_LIVE_LABEL: 'Ainda não há perguntas em destaque',
    SEARCH_QUESTIONS_LIVE_LABEL:
      'Pesquise no bate-papo as perguntas que deseja resolver mais tarde. Selecione-os e mova-os para esta seção. ',
    SOON_QUESTIONS_LIVE_LABEL:
      'Em breve o moderador postará as perguntas que o palestrante responderá durante o show. Lembre-se de votar no seu favorito',
    // Chat section
    UPS_ERROR_CHAT_LIVE:
      ' Ups! Ocorreu um erro ao obter informações sobre o chat. ',
    LOAD_CHAT_MESSAGE: 'Não se preocupe, vai demorar alguns segundos',
    JOIN_CHAT: 'Junte-se à conversa ',
    SIGN_UP: 'Login ou registro',
    LOCKED_RULES: 'Você foi bloqueado neste bate-papo por violar o',
    RULES_COMUNITY: 'normas da comunidade',
    NOT_LIVE: ' Você não poderá mais participar deste Live.',
    WELCOME_TO_CHAT: 'Bem vindo à sala de chat!',
    SEE_NEW_MESSAGES: 'Ver nuevos mensajes ',
    // MessageCard section
    RESPONSE_COMMENT_LABEL: 'Responder comentário',
    HIDDEN_QUESTION_LABEL: 'Esconder das Perguntas',
    MOVE_QUESTION_LABEL: 'Mover para perguntas',
    PIN_UP_COMMENT_LABEL: 'Postar comentário',
    HIDDEN_COMMENT_LABEL: 'Ocultar comentário',
    LOCK_USER_LABEL: 'Bloquear usuário',
    MODERATOR_CHAT: 'CHAT MODERATOR',
    SPEAKER: 'SPEAKER',
    // PinnedMessage
    LESS: 'menos',
    MORE: 'mais',
    // TextFieldForm section
    WRITE_MESSAGE_HERE: 'Escreva sua mensagem aqui ...',
    LOAD_EMOJIS: 'Carregando Emojis :)',
  },
};
